// @flow
import * as React from 'react';
import {Link} from 'docs/components';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {Text} from 'sail/Text';
import {Card, CardBody} from './framework';

type PartnerCardProps = {|
  title: string,
  text: string,
  href: string,
  icon: string,
|};

export const PartnerCard = ({title, text, href, icon}: PartnerCardProps) => (
  <Card bordered>
    <Link href={href} title={title}>
      <Group direction="horizontal" spacing={12}>
        <Box margin={{right: 12, top: 2}} style={{maxHeight: '40px'}}>
          <img alt="" src={icon} />
        </Box>
        <Group spacing={8}>
          <Text color="blue" weight="medium" size={15}>
            {title}
          </Text>
          <CardBody>{text}</CardBody>
        </Group>
      </Group>
    </Link>
  </Card>
);
